import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseSection from '../BaseSection';
import ParamsModal from '../ParamsModal';

const ParamsSection = memo(residenceData => {
  const { t } = useTranslation();
  const [showParams, setShowParams] = useState(false);

  const clickHandler = () => {
    setShowParams(true);
  };

  const {
    deadline,
    buildingClass,
    buildingsCount,
    blocks,
    apartmentsCount,
    liftsPerBlock,
    floorsPerBuilding,
    apartmentsPerFloor,
    technology,
    decoration,
    ceilingHeight,
    windowType,
    layout
  } = residenceData;

  return (
    <BaseSection>
      <div className="params">
        <div className="params__title">
          {t('residences.params_modal_content')}
        </div>
        <div className="params__items">
          {deadline && (
            <div>
              <span className="deadline">{t('residences.deadline')}</span>
              <span>{deadline}</span>
            </div>
          )}
          {buildingClass && (
            <div>
              <span className="class">{t('residences.class')}</span>
              <span>{buildingClass.name}</span>
            </div>
          )}
          {buildingsCount && (
            <div>
              <span className="buildings">
                {t('residences.buildings_count_param')}
              </span>
              <span>{buildingsCount}</span>
            </div>
          )}
          {blocks && (
            <div>
              <span className="blocks">{t('residences.blocks_count')}</span>
              <span>{blocks}</span>
            </div>
          )}
          {apartmentsCount && (
            <div>
              <span className="flats">{t('residences.apartments_count')}</span>
              <span>{apartmentsCount}</span>
            </div>
          )}
          {liftsPerBlock && (
            <div>
              <span className="elevators">
                {t('residences.lifts_per_block')}
              </span>
              <span>{liftsPerBlock}</span>
            </div>
          )}
          {floorsPerBuilding && (
            <div>
              <span className="floors">
                {t('residences.floors_per_building')}
              </span>
              <span>{floorsPerBuilding}</span>
            </div>
          )}
          {apartmentsPerFloor && (
            <div>
              <span className="flats">
                {t('residences.apartments_per_floor')}
              </span>
              <span>{apartmentsPerFloor}</span>
            </div>
          )}
        </div>
        {(residenceData.facilities?.length > 0 ||
          technology ||
          decoration ||
          ceilingHeight ||
          windowType ||
          layout) && (
          <div
            className="params__items--show"
            data-stat="residence-params"
            onClick={clickHandler}
            onKeyPress={clickHandler}
            role="button"
            tabIndex="0"
          >
            {t('residences.all_params')}
          </div>
        )}
      </div>
      {showParams && (
        <ParamsModal
          isOpen={showParams}
          hide={() => setShowParams(false)}
          residences={residenceData}
        />
      )}
    </BaseSection>
  );
});

ParamsSection.displayName = `ParamsSection`;

export default ParamsSection;
